module.exports = "/packs/review_complete_badge-cb2c23dbdb79c9583314c4d9a8745287.png";